import objectToArray from '../../utils/objectToArray';

export default {
  getExperimentsData() {
    const {clientExperiments} = window.start.siteDataV2;
    return {experiments: objectToArray(clientExperiments)};
  },
};
